import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { connect } from 'react-redux';

import Header from './common/Header';
import RouteFromPath from './routes/RouteFromPath';
import history from '../utils/history';
import routes from '../routes';

const App = ({ authenticated, checked, user }) => (
  <ConnectedRouter history={history}>
    <div>
      {authenticated && !user.isEmpty() && <Header />}
      { checked &&
        <Switch>
          {routes.map((route, index) =>
            <RouteFromPath
              key={`route${index}`}
              {...route}
              authenticated={authenticated}
            />
          )}
        </Switch>
      }
    </div>
  </ConnectedRouter>
);

const { bool, object } = PropTypes;

App.propTypes = {
  authenticated: bool.isRequired,
  checked: bool.isRequired,
  user: object.isRequired
};

const mapState = state => ({
  checked: state.getIn(['session', 'checked']),
  authenticated: state.getIn(['session', 'authenticated']),
  user: state.getIn(['session', 'user'])
});

export default connect(mapState)(App);



// WEBPACK FOOTER //
// ./src/components/App.js